import React from 'react'
const References




= () => {
  return (
    <div> <h1 className='input fit '>
      References</h1>

<div className='reference-card'>
<h1>Microsoft Learn</h1>
<p className='no-over'>Microsoft Learn--
  
 <a href=" https://learn.microsoft.com/en-us/users/
mVmClX-5727" className='text fit button'>Website</a></p>
</div>
        



        
<div className='reference-card'>
<h1>OpenAi</h1>
<p className='no-over'>Playground for api utilities, Dall E, and much more

  
 <a className='text fit button' href=" https://beta.openai.com">Website</a></p>
</div>




<div className='reference-card'>
<h1>Orielly Media</h1>
<p className='no-over'>A Great place to learn via videos/literature
  
<a className='text fit button' href="https://www.oreilly.com/online-learning/?utm_medium=search&utm_source=google.com&utm_campaign=B2B+Search&utm_content=live+demo&gclid=Cj0KCQiAz9ieBhCIARIsACB0oGJuWqNwUwNdViTHuhHYssJ2dDjjO_7LLc6T5DeECqLFgBRXaR3JYtQaAt9iEALw_wcB">Website</a></p>
</div>







<div className='reference-card'>
<h1>Moralis</h1>
<p className='no-over'>Web 3 Material
  
<a className='text fit button' href="https://moralis.io/?utm_source=gads&utm_campaign=17600841074&utm_medium=140711338200&network=g&device=c&gclid=Cj0KCQiAz9ieBhCIARIsACB0oGInNeP3T4PzTUSlheOsaDAfApdLqYQbuRDS_G0jNkcByo1JqVdqzQwaAgBvEALw_wcB">Website</a></p>
</div>






<div className='reference-card'>
<h1>Buildspace</h1>
<p className='no-over'>Web 3 and so much more
  <a className='text fit button' href="https://buildspace.so/">Website</a>
  <a className='text fit button' href="https://buildspace.so/mvmclx">Profile</a></p>
</div>






<div className='reference-card'>
<h1>Youtube Teachers & links</h1>
<p className='contain-the-p mlot no-over'>
  This is a personal preference, but I'm sure anyone could find value watching and listening to some of these people. 
  <a className='text fit button' href="https://www.youtube.com/@NetworkChuck">Network Chuck</a><a className='text fit button' href="https://www.youtube.com/c/TraversyMedia/videos"> Brad Traversy</a><a className='text fit button'  href="https://www.youtube.com/@javascriptmastery"> Javascript Mastery</a>
  <a className='text fit button' href="https://www.youtube.com/watch?v=ZdJSHEczi_0">Responsive Styling Demonstration</a>


  </p>

</div>






<div className='reference-card'>
<h1>Alchemy University</h1>
<p className='no-over'>Web 3 
  
<a className='text fit button' href="https://university.alchemy.com/">Website</a></p>
</div>

<div className='reference-card'>
<h1>Frontweb.io</h1>
<p className='no-over'>Modern coding challenges 
  
<a className='text fit button' href="http://frontweb.io">Website</a></p>
</div>


<div className='reference-card'>
<h1>Codepen</h1>
<p className='no-over'>Endless inspirational and imaginative contect from some an endless supply of out of the box thinking developers
  <a className='text fit button' href="https://codepen.io/johan-tirholm/pen/JjoXJNg">Globe</a>
<a className='text fit button' href="https://codepen.io/amit_sheen/pen/WNweryv">Turning pages with css</a>
<a className='text fit button' href="https://codepen.io/qkevinto/pen/EVGrGq">Three Scene</a>
<a className='text fit button' href="https://codepen.io/devmiglani/pen/YzOGoaO">Like Button</a>

</p>
</div>






<a href="/" className="back-link">Back to home</a>
















    </div>





  )
}






export default References